import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  .form-container {
    padding: 30px 0px 40px;
    background-color: #131f28;
    border-radius: 20px;
    box-shadow: 0px 0px 15px 1px #00000066;
    width: 50%;
  }
  .heading-container {
    display: flex;
    justify-content: center;
    h1 {
      color: #fff;
      font-size: 25px;
      text-align: center;
    }
  }
  .reset-requirement {
    display: flex;
    justify-content: center;
    align-items: center;
    .reset-heading {
      color: #fff;
      padding: 0px 50px;
      font-size: 14px;
      text-transform: uppercase;
    }
  }
  .form-details-container {
    padding: 0px 60px;
  }
  .password-container {
    margin-top: 5px;
  }
  .login-button-container {
    margin-top: 10px !important;
    .ant-btn {
      span {
        font-size: 14px;
      }
    }
  }
  .ant-form-item-explain-error {
    text-align: left;
  }
  @media screen and (max-width: 991px) {
    .form-container {
      width: 70%;
    }

    .reset-requirement {
      .reset-heading {
        color: #fff;
        /* width: 75%; */
        text-transform: uppercase;
      }
    }
    @media screen and (max-width: 768px) {
        .form-container {
      width: 100%;
    }
        .form-details-container {
        padding: 0px 40px;
      }
    }
    @media screen and (max-width: 510px) {
        .form-container {
      width: 90%;
    }
      .ant-form-item-explain-error {
        font-size: 12px;
      }
    }
  }
`;
